import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":"","ma-0":"","pa-5":""}},[_c(VCard,{staticClass:"d-flex",class:{
      'flex-row': _vm.$vuetify.breakpoint.mdAndUp,
      'flex-column': _vm.$vuetify.breakpoint.smAndDown,
    },attrs:{"color":"blue lighten-2","light":""}},[_c(VFlex,{attrs:{"xs12":"","md3":"","pa-5":""}},[_c(VImg,{staticStyle:{"border-radius":"50%"},attrs:{"src":_vm.project.img.src,"alt":_vm.project.img.alt}})],1),_c(VFlex,{staticClass:"d-flex align-stretch flex-column",attrs:{"xs12":"","md9":""}},[_c(VCardTitle,{class:{
          'display-1': _vm.$vuetify.breakpoint.mdAndUp,
          'title justify-center': _vm.$vuetify.breakpoint.smAndDown,
        }},[_c('p',[_vm._v("\n          "+_vm._s(_vm.project.name())+"\n        ")])]),_c(VCardSubtitle,{class:{
          'subtitle-1': _vm.$vuetify.breakpoint.mdAndUp,
          'subtitle-2': _vm.$vuetify.breakpoint.smAndDown,
        }},[_c('p',{staticClass:"text-justify"},[_vm._v("\n          "+_vm._s(_vm.project.description())+"\n        ")])]),_c(VSpacer),_c(VCardActions,{staticClass:"d-flex flex-row justify-end align-end"},[(_vm.project.action2.path)?_c(VBtn,{class:{
            title: _vm.$vuetify.breakpoint.mdAndUp,
            'subtitle-1': _vm.$vuetify.breakpoint.smAndDown,
          },attrs:{"to":_vm.project.action2.path,"text":""}},[_vm._v("\n          "+_vm._s(_vm.project.action2.name())+"\n        ")]):_vm._e(),(_vm.project.action1.path)?_c(VBtn,{class:{
            title: _vm.$vuetify.breakpoint.mdAndUp,
            'subtitle-1': _vm.$vuetify.breakpoint.smAndDown,
          },attrs:{"color":"purple","text":"","to":_vm.getRouterLink(_vm.project.action1)}},[_vm._v("\n          "+_vm._s(_vm.project.action1.name())+"\n        ")]):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }